import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MerchOrderSuccessContent from '../components/Merch/MerchOrderSuccessContent';
import {
  clearMerchCheckoutSession,
  requestMerchOrderConfirmationEmail,
  resolveMerchOrderDocumentId,
} from '../utils/merchOrderCheckout';
import { useAuth } from '../contexts/AuthContext';

function MerchOrderSuccess() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { userData, requestUserData } = useAuth();
  const summary = state || null;
  const emailRequestedRef = useRef(false);

  useEffect(() => {
    if (summary?.productName) {
      clearMerchCheckoutSession();
    } else {
      navigate('/merch', { replace: true });
    }
  }, [summary, navigate]);

  useEffect(() => {
    if (!summary?.productName || emailRequestedRef.current) return;

    emailRequestedRef.current = true;

    const sendConfirmationEmail = async () => {
      let orderDocumentId =
        summary.orderDocumentId || summary.documentId || null;

      if (!orderDocumentId && requestUserData) {
        const refreshedUser = await requestUserData({ withLoading: false });
        orderDocumentId = resolveMerchOrderDocumentId(
          summary,
          refreshedUser || userData
        );
      } else if (!orderDocumentId) {
        orderDocumentId = resolveMerchOrderDocumentId(summary, userData);
      }

      try {
        await requestMerchOrderConfirmationEmail({
          orderDocumentId: orderDocumentId || undefined,
          localPaymentIntentId: summary.localPaymentIntentId || undefined,
          paymentIntentId: summary.paymentIntentId || undefined,
        });
      } catch (error) {
        console.warn('Merch confirmation email request failed:', error);
      }
    };

    sendConfirmationEmail();
  }, [summary, userData, requestUserData]);

  if (!summary?.productName) {
    return null;
  }

  return <MerchOrderSuccessContent summary={summary} />;
}

export default MerchOrderSuccess;
